var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_675_24951)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_675_24951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H15C6.71573 0 0 6.71573 0 15V25C0 33.2843 6.71573 40 15 40H25C33.2843 40 40 33.2843 40 25V15C40 6.71573 33.2843 0 25 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_675_24951)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1H16C7.71573 1 1 7.71573 1 16V24C1 32.2843 7.71573 39 16 39H24C32.2843 39 39 32.2843 39 24V16C39 7.71573 32.2843 1 24 1Z",
    stroke: "#47D5CD",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_675_24951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 24,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5037 21.9557C16.1715 21.8852 16.8215 21.8175 17.4715 21.748C18.5841 21.6293 19.6964 21.5095 20.8087 21.3901C21.8208 21.2813 22.833 21.1723 23.8452 21.0637C24.6959 20.9723 25.5464 20.8802 26.397 20.7905C27.1904 20.7069 27.9841 20.6277 28.777 20.5401C28.82 20.5354 28.8811 20.478 28.8917 20.4349C28.9358 20.2562 28.9599 20.0729 28.998 19.8926C29.3051 18.4382 29.6139 16.9843 29.9217 15.5299C29.9954 15.1822 30.0675 14.8338 30.1425 14.4759H13.9268C14.4538 16.9756 14.9766 19.4561 15.5037 21.9557ZM11.5811 11.7147C10.919 11.7147 10.2703 11.7149 9.62151 11.7147C9.36412 11.7147 9.10653 11.7187 8.84914 11.713C8.35977 11.7018 7.99401 11.3216 8.00007 10.8373C8.0065 10.3659 8.38094 10.0023 8.86819 10.0015C9.88694 9.99955 10.9057 9.99955 11.9244 10.0012C12.5562 10.0021 13.0733 10.4288 13.2029 11.0498C13.3091 11.5585 13.4215 12.066 13.5206 12.5762C13.5468 12.7106 13.5943 12.7556 13.7373 12.755C15.1534 12.7489 16.5696 12.7514 17.9857 12.7514C19.5131 12.7514 21.0404 12.7514 22.5678 12.7514C24.8737 12.7514 27.1794 12.751 29.4852 12.7518C29.9435 12.752 30.403 12.7785 30.8602 12.7567C31.4895 12.7269 32.1419 13.3508 31.9729 14.1423C31.5308 16.2132 31.0952 18.2854 30.6568 20.3572C30.605 20.6029 30.5542 20.8491 30.5014 21.0948C30.367 21.7218 29.9367 22.1309 29.2969 22.2046C28.0969 22.3424 26.8951 22.4662 25.6941 22.5955C24.5708 22.7166 23.4475 22.8379 22.324 22.9577C21.1393 23.0841 19.9544 23.2083 18.7697 23.3343C17.8083 23.4367 16.8469 23.5404 15.8644 23.6456C15.9437 24.0258 16.021 24.3947 16.1023 24.784C16.1751 24.784 16.2462 24.784 16.3173 24.784C20.3978 24.784 24.4785 24.7848 28.559 24.7825C28.8538 24.7823 29.1169 24.85 29.3102 25.0822C29.542 25.3605 29.5945 25.6763 29.4372 26.0065C29.2846 26.3278 29.0213 26.4974 28.6621 26.4978C27.1954 26.4995 25.7288 26.4984 24.2624 26.4984C22.9865 26.4984 21.7106 26.4984 20.4346 26.4984C18.8908 26.4984 17.3469 26.4988 15.803 26.498C15.1174 26.4978 14.6166 26.0747 14.478 25.4033C14.2216 24.161 13.9543 22.9209 13.6937 21.6795C13.5538 21.0127 13.4211 20.3443 13.2797 19.6779C12.8922 17.853 12.501 16.0286 12.113 14.2036C11.9481 13.4287 11.7875 12.653 11.6245 11.8777C11.6141 11.8286 11.5989 11.7807 11.5811 11.7147ZM26.5979 30.967C25.6429 30.9653 24.8851 30.2035 24.8881 29.2481C24.8911 28.2941 25.655 27.5327 26.6064 27.5357C27.5578 27.5387 28.3211 28.3053 28.3198 29.2568C28.3186 30.2067 27.5513 30.9687 26.5979 30.967ZM17.4767 30.9669C16.5289 30.9677 15.7608 30.2093 15.7589 29.2708C15.757 28.3035 16.5162 27.5356 17.4736 27.536C18.4261 27.5364 19.1895 28.2992 19.1891 29.25C19.1887 30.208 18.4326 30.966 17.4767 30.9669Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_675_24951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 4H4V36H36V4Z",
    fill: "#47D5CD"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_675_24951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d0384ad1fc586672de0e365bf6982b8d.svg";
export { ForwardRef as ReactComponent };